
import type { Benefit, Faq } from '@/lib/supabase/products';

// Default benefits to add to products that don't have any
export const DEFAULT_BENEFITS: Benefit[] = [
  {
    id: crypto.randomUUID(),
    title: 'Haute qualité',
    description: 'Fabriqué avec les meilleurs matériaux',
    icon: 'star',
    visible: true
  },
  {
    id: crypto.randomUUID(),
    title: 'Livraison rapide',
    description: 'Livraison en 24-48h',
    icon: 'award',
    visible: true
  },
  {
    id: crypto.randomUUID(),
    title: 'Satisfaction garantie',
    description: '30 jours satisfait ou remboursé',
    icon: 'thumbs-up',
    visible: true
  }
];

// Default FAQs to add to products that don't have any
export const DEFAULT_FAQS: Faq[] = [
  {
    id: crypto.randomUUID(),
    question: 'Comment utiliser ce produit?',
    answer: 'Instructions détaillées pour l\'utilisation de ce produit...',
    visible: true
  },
  {
    id: crypto.randomUUID(),
    question: 'Quelle est la garantie?',
    answer: 'Nous offrons une garantie de 30 jours sur ce produit.',
    visible: true
  },
  {
    id: crypto.randomUUID(),
    question: 'Puis-je retourner le produit?',
    answer: 'Oui, vous pouvez retourner le produit dans les 14 jours suivant l\'achat.',
    visible: true
  }
];
